import { Extension } from '@tiptap/core';

export const disableShortcutsExtension = (shortcuts: string[]) => Extension.create({
  addKeyboardShortcuts: () => Object.fromEntries(shortcuts.map(s => [s, () => true])),
});
